import { Log, apiRequest, Wait } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Pregunta.types';
import { IPregunta } from './Pregunta.lib';
import { Publicacion } from '../Publicaciones';
import { UsuarioActual } from '@/views/a-login/login-controlador';
import { isString } from 'util';
import moment from 'moment';

export class Pregunta extends IPregunta
{

    public static async create( id: number ): Promise<Pregunta>
    {
        let o = new Pregunta();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/mercadolibre/preguntas';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Pregunta>; Error?: boolean; }>
    {

        let a: Array<Pregunta> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/mercadolibre/preguntas` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Pregunta( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public get Hola() { return `Hola ${this.Usuario.Nickname}!`; }
    public get Chau() { return `Saludos! ${UsuarioActual.Nombre} de ${this.Cuenta}.`; }
    public Formatear( respuesta: string, hola: boolean, chau: boolean ): string
    {
        let e = respuesta;
        if ( hola ) e = this.Hola + ' ' + e;
        if ( chau ) e = e + ' ' + this.Chau;
        return e;
    }
    public async contestar(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    return this.set();
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async CargarPublicacion()
    {
        if ( isString( this.Publicacion ) )
        {
            let publicacion = await Publicacion.create( this.Publicacion, this.Cuenta );
            if ( publicacion )
            {
                this.Publicacion = publicacion;
            }
        }
    }


    public async TestMismaPublicacion( publicaciones: Publicacion[] )
    {
        return publicaciones.filter( x => isString( this.Publicacion ) ? x.Id == this.Publicacion : x.Id == this.Publicacion.Id ) != null;
    }

    public async Responder( respuesta: string ): Promise<'ya-respondida' | 'ok' | false>
    {
        if ( this.Existe )
        {
            let request = new apiRequest( `${this.Route}/${this.Id}/responder` );
            request.body.respuesta = respuesta;
            if ( request.post() )
            {
                if ( request.data.error && request.data.error == 'ya-respondida' )
                    return 'ya-respondida';
                else
                {
                    this.FechaRespuesta = moment();
                    this.UsuarioSistema.Nombre = UsuarioActual.Nombre;
                    this.UsuarioSistema.Apellido = UsuarioActual.Apellido;
                    this.UsuarioSistema.Usuario = UsuarioActual.Usuario;
                    this.Respuesta = respuesta;
                    return 'ok';
                }
            }
        }
        return false;
    }

    public async Recargar( x: any )
    {
        this.Json = x;
        this.set();
    }
}